import React from 'react';
import {
    FormControl,
    Input,
    FormLabel,
    RadioGroup,
    HStack,
    Radio,
    Select,
    Button,
    VStack,
    Box,
    FormErrorMessage
} from '@chakra-ui/react';
import { Formik, Form, Field, useField } from 'formik';
import AddressInput from './AddressInput';
import { CONSUMER_DEFAULT_VALUES } from 'constants/consumer';
import * as Yup from 'yup';
import { occupencyType } from 'constants/Select-constants/index';
import { useUpdateConsumerMutation } from 'reducers/consumer.service';
import { GENDERLIST } from 'constants/Select-constants';

const TextField = ({ label, ...props }) => {
    const [field, meta] = useField(props);
    return (
        <FormControl isInvalid={meta.touched && !!meta.error} mb={4}>
            <FormLabel>{label}</FormLabel>
            <Input {...field} {...props} />
            <FormErrorMessage>{meta.error}</FormErrorMessage>
        </FormControl>
    );
};

// const CheckboxField = ({ children, ...props }) => {
//     const [field] = useField({ ...props, type: 'checkbox' });
//     return (
//         <Checkbox {...field} {...props}>
//             {children}
//         </Checkbox>
//     );
// };

export default function ConsumerForm({ defaultValues = CONSUMER_DEFAULT_VALUES, data, afterUpdateHandler = ()=>{}, handleCancel = ()=>{} }) {
    const [updateConsumer, { isLoading }] = useUpdateConsumerMutation();
    const handleUpdate = (values, actions)=>{
        updateConsumer({ id: data?._id , body: values }).unwrap().then(()=>{
            afterUpdateHandler();
        });
    };
    return (
        <Formik
            initialValues={defaultValues}
            validationSchema={Yup.object({
                FirstName: Yup.string().required('Required'),
                LastName: Yup.string().required('Required'),
                gender: Yup.string().required(),
                OccupencyType: Yup.string().required(),
                isIdAddressCurrentResidence: Yup.boolean().required(),
                isOwnProperty: Yup.boolean().required(),
                isOnRent: Yup.boolean().required()
            })}
            onSubmit={handleUpdate}
        >
            {({ handleSubmit , setValues, setFieldValue }) => (
                <Form onSubmit={handleSubmit}>
                    <VStack align="stretch" spacing={4}>
                        <TextField name="FirstName" label="First Name" />
                        <TextField name="LastName" label="Last Name" />

                        <FormControl as="fieldset">
                            <FormLabel as="legend">Gender</FormLabel>
                            <Field name="gender">
                                {({ field }) => (
                                    <RadioGroup
                                        {...field}
                                        onChange={(val) => setFieldValue('gender', val)}
                                        value={field.value}
                                    >

                                        {
                                            GENDERLIST.map((row, index)=>(
                                                <Radio value={row.value} width={'100%'} key={index}>{row.label}</Radio>
                                            ))
                                        }
                                    </RadioGroup>
                                )}
                            </Field>
                        </FormControl>
                        <Box>
                            <AddressInput />
                        </Box>
                        <FormControl>
                            <FormLabel>Occupency Type</FormLabel>
                            <Field name="OccupencyType" as={Select} placeholder="Select">
                                {
                                    occupencyType.map((row, index)=>(
                                        <option key={index} value={row.value}>{row.label}</option>

                                    ))
                                }
                            </Field>
                        </FormControl>
                        {/* <FormControl>

                            <CheckboxField name="isIdAddressCurrentResidence">
                          The address on my driver&apos;s license is my current residence.
                            </CheckboxField>
                        </FormControl>
                        <FormControl>

                            <CheckboxField name="isOwnProperty">
                            I own and occupy this property.
                            </CheckboxField>
                        </FormControl>
                        <FormControl>
                            <CheckboxField name="isOnRent">
                            I rent this property.
                            </CheckboxField>
                        </FormControl> */}
                        <HStack justify="flex-end" gap={'0.5rem'}>
                            <Button variant="outline" type="reset" onClick={handleCancel }>
                                Cancel
                            </Button>
                            <Button disabled={isLoading} colorScheme="blue" type="submit">
                                {
                                    isLoading ? 'Saving...' : 'Save'
                                }
                            </Button>
                        </HStack>
                    </VStack>
                </Form>
            )}
        </Formik>
    );
}
